module.exports = __webpack_public_path__ + "static/media/modelo-envelope.758472cd.svg";